import { update, ref } from 'firebase/database';
import { db } from '@/core/firebase/config';
import { getEnvDbPrefix } from '@/core/firebase/config';

export default function useSavePreferredOffice() {
  return (userId: string, officeId: string) => {
    const dbStringRef = getEnvDbPrefix(`user/${userId}`);
    const bookingRef = ref(db, dbStringRef);

    update(bookingRef, {
      officeId,
    });
  };
}
